/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-09 10:25:17
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-19 11:13:05
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/chart.js
 */

import { axisLeft } from "d3";
import { toVisualThousands } from "../utils";
import { labelFont, xAxisLabelColor, yAxisLabelColor } from "../visualConfig";

export default ({ title, list = [], color = [] }) => {
  console.log('color', color)

  return {
    title: {
      text: 'ESG传播影响力最高媒体源TOP10',
      textAlign: 'center',
      top: '6%',
      textStyle: {
        fontSize: '15px'
      }
    },
    legend: {
      // show: false,
      bottom: '6%',
      right: '4%',
      itemWidth: 10,
      itemHeight: 10
    },
    color,
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    grid: {
      top: '13%',
      left: '2%',
      right: '12%',
      bottom: 20,
      containLabel: true
    },
    yAxis: {
      show: true,
      type: 'category',
      data: title.reverse(),
      axisTick: {
        show: false
      },
      axisLabel: { ...xAxisLabelColor, fontSize: '12px' },
    },
    xAxis: {
      show: true,
      type: 'value',
      name: '(单位：DB)',
      splitLine: false,
      nameTextStyle: {
        fontSize: 10,
        // fontWeight: 'bold',
        color: '#000',
        align: 'right',
        rich: {
          db: {
            fontSize: 16,
            fontStyle: 'italic'
          }
        },
      },
      axisLabel: { ...yAxisLabelColor, show: false },
    },
    series: [
      {
        name: `数字品牌价值`,
        type: 'bar',
        barWidth: '45%',
        label: {
          show: true,
          formatter: (ele) => toVisualThousands(ele.value),
          ...labelFont,
        },
        data: list.map((item, index) => ({
          value: item,
          itemStyle: { color: color[index] },
          label: { position: item == Math.max(...list) ? 'insideRight' : 'outside' }
        })),
      }
    ]
  };
}


// WEBPACK FOOTER //
// src/routes/visualChart/P26/chart.js